import { Provider } from 'react-redux'
import { ThemeProvider } from 'styled-components'

import { MediaQueryProvider } from 'contexts/MediaQueryContext'

import { isTouchDevice } from '../../components/utils/displayUtils'
import TouchDeviceContext from '../../contexts/TouchDeviceContext'
import GlobalStyle from '../../styles/GlobalStyles'

import Notifier from '../../components/Notifier'
import AuthModal from '../../components/auth/AuthModal'

import styledTheme from '../../styles/theme'
import configureStore from '../../typedRedux/configureStoreWithHistory'

const { store } = configureStore()

const StaticWrapper = ({ isPage = false, children }) => (
  <TouchDeviceContext.Provider value={isTouchDevice()}>
    <Provider store={store} key="provider">
      <MediaQueryProvider>
        <ThemeProvider theme={styledTheme}>
          {isPage ? (
            <>
              <GlobalStyle />
              <Notifier />
              <AuthModal />
              {children}
            </>
          ) : (
            children
          )}
        </ThemeProvider>
      </MediaQueryProvider>
    </Provider>
  </TouchDeviceContext.Provider>
)

export default StaticWrapper
